import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const navItems = [
  { key: "home", label: "首页", to: "/", path: "/" },
  { key: "works", label: "参赛作品", to: "/works", path: "/works" },
  { key: "hot", label: "热门排行", to: "/works?sort=hot", path: "/works", search: "sort=hot" },
  { key: "about", label: "大赛说明", to: "/about", path: "/about" },
];

export default function SiteHeader() {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname, location.search]);

  const isActive = (item: (typeof navItems)[number]) => {
    if (item.search) {
      return location.pathname === item.path && location.search.includes(item.search);
    }
    if (item.path === "/works") {
      return location.pathname === "/works" && !location.search.includes("sort=");
    }
    return location.pathname === item.path;
  };

  return (
    <header className="sticky top-0 z-50">
      <div className="hidden md:block bg-primary-600 text-background-50">
        <div className="px-4 md:px-8 h-9 flex items-center justify-between text-xs">
          <p className="flex items-center gap-2">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-megaphone-line" />
            </span>
            本期爆料大赛征稿进行中，投稿作品随到随审
          </p>
          <p className="hidden lg:flex items-center gap-4 text-background-100">
            <span className="flex items-center gap-1.5">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-mail-line" />
              </span>
              submit@baoliao-contest.example.com
            </span>
            <span className="text-primary-200">|</span>
            <span>投稿截止 2026 年 10 月 20 日</span>
          </p>
        </div>
      </div>

      <div
        className={`border-b transition-colors duration-300 ${
          scrolled || open
            ? "bg-background-50/95 backdrop-blur border-background-200"
            : "bg-background-50 border-transparent"
        }`}
      >
        <div className="px-4 md:px-8 h-16 md:h-20 flex items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2.5 shrink-0" aria-label="爆料大赛首页">
            <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center font-heading text-lg font-bold">
              爆
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg font-bold text-foreground-950 tracking-tight">爆料大赛</span>
              <span className="font-label text-[10px] text-foreground-500 tracking-[0.22em] mt-0.5">
                BAOLIAO OPEN
              </span>
            </span>
          </Link>

          <nav className="hidden lg:flex items-center gap-1" aria-label="主导航">
            {navItems.map((item) => (
              <Link
                key={item.key}
                to={item.to}
                className={`px-3.5 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                  isActive(item)
                    ? "text-primary-600 bg-primary-100/70"
                    : "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <Link
              to="/about#submit"
              className="hidden sm:inline-flex items-center gap-1.5 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium px-4 md:px-5 py-2.5 rounded-md whitespace-nowrap transition-colors cursor-pointer"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-quill-pen-line" />
              </span>
              我要投稿
            </Link>
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              aria-label={open ? "关闭菜单" : "打开菜单"}
              aria-expanded={open}
              className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-200 text-foreground-800 hover:bg-background-100 cursor-pointer text-xl"
            >
              <i className={open ? "ri-close-line" : "ri-menu-2-line"} />
            </button>
          </div>
        </div>

        {open && (
          <nav className="lg:hidden border-t border-background-200 bg-background-50" aria-label="移动端导航">
            <ul className="px-4 py-3 flex flex-col">
              {navItems.map((item) => (
                <li key={item.key}>
                  <Link
                    to={item.to}
                    className={`flex items-center justify-between px-3 py-3 rounded-md text-sm font-medium cursor-pointer ${
                      isActive(item) ? "text-primary-600 bg-primary-100/70" : "text-foreground-800 hover:bg-background-100"
                    }`}
                  >
                    {item.label}
                    <span className="w-4 h-4 flex items-center justify-center text-foreground-400">
                      <i className="ri-arrow-right-s-line" />
                    </span>
                  </Link>
                </li>
              ))}
              <li className="pt-2">
                <Link
                  to="/about#submit"
                  className="flex items-center justify-center gap-1.5 bg-primary-500 text-background-50 text-sm font-medium px-4 py-3 rounded-md whitespace-nowrap cursor-pointer"
                >
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-quill-pen-line" />
                  </span>
                  我要投稿
                </Link>
              </li>
            </ul>
          </nav>
        )}
      </div>
    </header>
  );
}